import { render, staticRenderFns } from "./zxwrite.vue?vue&type=template&id=4c469d85&scoped=true&"
import script from "./zxwrite.vue?vue&type=script&lang=js&"
export * from "./zxwrite.vue?vue&type=script&lang=js&"
import style0 from "./zxwrite.vue?vue&type=style&index=0&id=4c469d85&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c469d85",
  null
  
)

export default component.exports